let __flarum_default_export__;
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import Separator from 'flarum/common/components/Separator';
import ItemList from 'flarum/common/utils/ItemList';

/**
 * The component the controls are rendered under, exposing the callbacks the
 * actions report back through.
 */

/**
 * The `WarningControls` utility constructs a list of buttons for a warning which
 * perform actions on it.
 */
export default __flarum_default_export__ = {
  /**
   * Get a list of controls for a warning.
   *
   * @param context The parent component under which the controls menu will
   *     be displayed.
   */
  controls(warning, context) {
    const items = new ItemList();
    ['user', 'moderation', 'destructive'].forEach(section => {
      const controls = this["".concat(section, "Controls")](warning, context).toArray();
      if (controls.length) {
        controls.forEach(item => items.add(item.itemName, item));
        items.add(section + 'Separator', Separator.component());
      }
    });
    return items;
  },
  /**
   * Get controls for a warning pertaining to the current user (e.g. report).
   */
  userControls(_warning, _context) {
    return new ItemList();
  },
  /**
   * Get controls for a warning pertaining to moderation (e.g. edit).
   */
  moderationControls(_warning, _context) {
    return new ItemList();
  },
  /**
   * Get controls for a warning that are destructive (e.g. delete).
   */
  destructiveControls(warning, context) {
    var _app$session$user, _app$session$user2, _app$session$user3;
    const items = new ItemList();
    if (!warning.isHidden() && (_app$session$user = app.session.user) != null && _app$session$user.canManageWarnings()) {
      items.add('hide', m(Button, {
        icon: "far fa-trash-alt",
        onclick: this.hideAction.bind(warning, context)
      }, app.translator.trans('fof-moderator-warnings.forum.warning_controls.delete_button')));
    }
    if (warning.isHidden() && (_app$session$user2 = app.session.user) != null && _app$session$user2.canManageWarnings()) {
      items.add('restore', m(Button, {
        icon: "fas fa-reply",
        onclick: this.restoreAction.bind(warning, context)
      }, app.translator.trans('fof-moderator-warnings.forum.warning_controls.restore_button')));
    }
    if (warning.isHidden() && (_app$session$user3 = app.session.user) != null && _app$session$user3.canDeleteWarnings()) {
      items.add('delete', m(Button, {
        icon: "fas fa-times",
        onclick: this.deleteAction.bind(warning, context)
      }, app.translator.trans('fof-moderator-warnings.forum.warning_controls.delete_forever_button')));
    }
    return items;
  },
  /**
   * Hide a warning.
   */
  hideAction(context) {
    return this.save({
      isHidden: true
    }).then(() => {
      var _context$attrs, _context$attrs$onchan;
      context == null || (_context$attrs = context.attrs) == null || (_context$attrs$onchan = _context$attrs.onchange) == null || _context$attrs$onchan.call(_context$attrs, this);
      m.redraw();
    });
  },
  /**
   * Restore a warning.
   */
  restoreAction(context) {
    return this.save({
      isHidden: false
    }).then(() => {
      var _context$attrs2, _context$attrs2$oncha;
      context == null || (_context$attrs2 = context.attrs) == null || (_context$attrs2$oncha = _context$attrs2.onchange) == null || _context$attrs2$oncha.call(_context$attrs2, this);
      m.redraw();
    });
  },
  /**
   * Delete a warning.
   */
  deleteAction(context) {
    if (context) context.loading = true;
    const done = () => {
      if (context) context.loading = false;
      m.redraw();
    };
    return this.delete().then(() => {
      var _context$attrs3, _context$attrs3$ondel;
      context == null || (_context$attrs3 = context.attrs) == null || (_context$attrs3$ondel = _context$attrs3.ondelete) == null || _context$attrs3$ondel.call(_context$attrs3, this);
      done();
    },
    // Not swallowed: app.request shows its own error alert.
    error => {
      done();
      throw error;
    });
  }
};
flarum.reg.add('fof-moderator-warnings', 'forum/components/WarningControls', __flarum_default_export__);